import {tabClasses, ThemeOptions} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiTabs = ({tabs}: Tokens): ThemeOptions['components'] => ({
  MuiTab: {
    defaultProps: {
      focusRipple: false
    },
    styleOverrides: {
      root: {
        fontSize: tabs.label.desktop.font.size,
        fontWeight: tabs.label.desktop.font.weight,
        lineHeight: tabs.label.desktop.font.lineHeight,
        color: tabs.label.desktop.font.color,
        padding: tabs.label.desktop.padding.all,
        borderBottom: `${tabs.indicator.desktop.height} solid`,
        borderBottomColor: tabs.indicator.desktop.background.color,
        marginTop: 4,
        marginBottom: 4,
        textTransform: 'none',
        '&:hover': {
          color: tabs.label.desktop.hover.font.color
        },
        [`&.${tabClasses.selected}`]: {
          color: tabs.label.desktop.hover.font.color
        }
      }
    }
  },
  MuiTabs: {
    defaultProps: {
      centered: true,
      variant: 'fullWidth'
    },
    styleOverrides: {
      root: {
        marginBottom: tabs.control.desktop.margin.bottom
      },
      flexContainer: {
        marginRight: 4,
        marginLeft: 4
      },
      indicator: {
        background: tabs.indicator.desktop.active.background.color,
        height: tabs.indicator.desktop.active.height,
        borderRadius: tabs.indicator.desktop.active.border.radius.all,
        bottom: tabs.indicator.desktop.active.height
      }
    }
  }
});
